import { defineMessages } from 'react-intl';

export const scope = 'app.containers.NavigatorAvailabilityPanel';

export default defineMessages({
  offlineForLiveChat: {
    id: `${scope}.offlineForLiveChat`,
    defaultMessage: 'Offline for live chat',
  },
});
